export const DATA_NUM = 'data-num';
export const DATA_INTERSECTING = 'data-intersecting';
export const DATA_DIRTY = 'data-dirty';
export const DATA_INDEX = 'data-index';
export const DATA_RAW = 'data-raw';

export const zoomValueList = [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
